(function () {
  /* Dismissal is remembered for the BROWSING SESSION, not forever.
   *
   * This used to write to localStorage, which has no expiry: one tap of the ×
   * on a phone and the bar never came back on that device again. That is why
   * the owner reported the announcement "doesn't appear on mobiles" -- nothing
   * was broken, it had simply been dismissed once and stayed dismissed.
   *
   * sessionStorage keeps the dismissal for the rest of the visit (so it does
   * not reappear on every page they open) and clears when the tab closes, so a
   * returning customer sees the current notice. For a bar advertising booking
   * slots that is the behaviour that matches its purpose.
   *
   * The read is deliberately tolerant of the old key: anyone who dismissed it
   * under the previous build has a stale localStorage entry, and leaving it
   * unread is what lets the bar come back for them. */
  function init() {
    document.querySelectorAll('[data-or-anno]').forEach(function (bar) {
      var key = bar.getAttribute('data-storage-key');
      if (key) {
        try { if (sessionStorage.getItem('or-anno:' + key) === '1') { bar.hidden = true; } } catch (e) {}
        var btn = bar.querySelector('[data-or-anno-close]');
        if (btn) btn.addEventListener('click', function () {
          bar.hidden = true;
          try { sessionStorage.setItem('or-anno:' + key, '1'); } catch (e) {}
        });
      }
    });
    document.querySelectorAll('[data-or-marquee] .or-anno__marquee-track').forEach(function (track) {
      track.innerHTML += track.innerHTML;
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
